/** API `invalid_fields` key → human field title for the player form summary toast. */
export const BE_TO_FIELD_TITLE: Record<string, string> = {
  name_first: 'First Name',
  name_last: 'Last Name',
  birth_date: 'Date of Birth',
  gender_id: 'Gender',
  height: 'Height',
  weight: 'Weight',
  email: 'Email',
  phone_number: 'Phone Number',
  alternate_phone_number: 'Alternate Phone Number',
  preferred_contact_method: 'Preferred Contact Method',
  preferred_language: 'Preferred Language',
  emergency_contact_name: 'Emergency Contact Name',
  emergency_contact_relationship: 'Emergency Contact Relationship',
  emergency_contact_phone_number: 'Emergency Contact Phone',
  'address.street_1': 'Address',
  'address.street_2': 'Address Line 2',
  'address.city': 'City',
  'address.postal_code': 'Postal Code',
  'address.province_id': 'Province',
  'address.country_id': 'Country',
  league_registration_number: 'League Registration Number',
  hockey_usa_number: 'USA Hockey Number',
  hockey_canada_number: 'Hockey Canada Number',
  custom_membership_number: 'Membership Number',
  loyalty_number: 'Loyalty Number',
  instagram: 'Instagram',
  facebook: 'Facebook',
  tiktok: 'TikTok',
  youtube: 'YouTube',
}
